<dx-drop-down-box class="icon-picker-drop-down-box"
                  valueExpr="name"
                  displayExpr="label"
                  [(value)]="value"
                  [dataSource]="icons"
                  [showClearButton]="true"
                  (onValueChanged)="onValueChanged($event)"
                  (onOpened)="onOpened()"
                  (onClosed)="onClosed()"
                  [(opened)]="popupVisible"
                  [readOnly]="disabled"
                  placeholder="Select an icon...">
    <dxo-drop-down-options [minWidth]="400"
                           [height]="500"
                           [shading]="false"
                           [wrapperAttr]="{class: 'icon-picker-popover'}"></dxo-drop-down-options>
    <dxo-drop-down-box-field-addons beforeTemplate="beforeDropDownBox"></dxo-drop-down-box-field-addons>
    <div *dxTemplate="let _ of 'beforeDropDownBox'">
        @if (value) {
            <i class="select-box-icon"
               [ngClass]="[iconStyle, 'fa-fw', value, 'ms-2']"></i>
        }
    </div>

    <div #iconPickerContent
         class="icon-picker-content"
         (mousemove)="handleMouseMove($event)"
         (mouseleave)="handleMouseLeave()">
        <div class="search-container">
            <dx-text-box [value]="searchTerm"
                         (onValueChanged)="onSearchTermChange($event.value)"
                         valueChangeEvent="keyup"
                         placeholder="Type to search icons..."
                         mode="search"></dx-text-box>
        </div>


        <div *adaptLoading="loading"
             class="picker-body">
            @if (showCategories && filteredGroups.length > 0) {
                <dx-scroll-view [useNative]="true"
                                (onScroll)="onScroll()">
                    <div class="category-sidebar">
                        @for (cat of categories; track cat.name) {
                            <div class="category-icon"
                                 [id]="'category-icon-' + cat.name"
                                 [class.active]="activeCategory === cat.name"
                                 [attr.data-label]="cat.label"
                                 (click)="scrollToCategory(cat)">
                                <i [ngClass]="[iconStyle, 'fa-fw', cat.icon]"></i>
                            </div>
                        }
                    </div>
                </dx-scroll-view>
            }

            <dx-scroll-view class="flex-grow-1"
                            [useNative]="true"
                            (onScroll)="onScroll()">
                <div #iconsList
                     class="icons-list">
                    @let currentValue = confirmIconSelection ? selectedValue : value;
                    @for (group of filteredGroups; track group.category.name) {
                        <div class="category-group"
                             [id]="'category-' + group.category.name">
                            @if (showCategories) {
                                <div class="category-header"
                                     [attr.data-category-name]="group.category.name">{{ group.category.label ?? group.category.name }}
                                </div>
                            }
                            <div class="icons-grid">
                                @for (icon of group.icons; track icon.name) {
                                    <div class="icon-item"
                                         [id]="'icon-' + icon.name"
                                         [class.selected]="currentValue === icon.name"
                                         (click)="selectIcon(icon)"
                                         [attr.data-label]="icon.label">
                                        <i [ngClass]="[iconStyle, 'fa-fw', icon.name]"></i>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    @if (filteredGroups.length === 0) {
                        <div class="text-center text-muted">
                            No icons found.
                        </div>
                    }
                </div>
            </dx-scroll-view>
        </div>

        <div class="picker-tooltip"
             [class.visible]="tooltipVisible"
             [style.transform]="tooltipTransform">
            {{ tooltipText }}
        </div>

        @if (confirmIconSelection) {
            <div class="footer-container p-2 border-top d-flex justify-content-end gap-1">
                <button adaptButton="iconlessOk"
                        class="btn-small"
                        (click)="onConfirm()"></button>
                <button adaptButton="iconlessCancel"
                        class="btn-small"
                        (click)="onCancel()"></button>
            </div>
        }
    </div>
</dx-drop-down-box>
